import { render } from "./LbrxKioskFifthTheme.vue?vue&type=template&id=a400b13a&scoped=true"
import script from "./LbrxKioskFifthTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskFifthTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskFifthTheme.vue?vue&type=style&index=0&id=a400b13a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a400b13a"]])

export default __exports__